import axios from "axios";

const requestLandingMain = () => {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/app/landing/main`);
};

export { requestLandingMain };
